import React, { forwardRef, ReactElement } from 'react';
// material-ui
import { OutlinedInput } from '@mui/material';

// project import
import GoogleMaps from 'assets/images/icons/Google_Maps_icon.svg';

type InputWithIconProps = {
   icon: ReactElement,
   placeholder: string,
   condensed?: boolean,
   value?: string,
   fullWidth?: boolean,
   disabled?: boolean,
   id?: string,
   inputProps?: any,
   googleMaps?: boolean,
   endAdornment?: React.ReactNode,
   onChangeHandler?: (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void,
}

const InputWithIcon = forwardRef<HTMLInputElement, InputWithIconProps>(
   ({ icon, placeholder, condensed, value, fullWidth, disabled, id, inputProps, googleMaps, endAdornment, onChangeHandler }, ref) => {
       return (
           <OutlinedInput
               id={id ? id : `start-adornment-email` + placeholder}
               placeholder={placeholder}
               inputRef={ref}
               value={value}
               startAdornment={icon}
               endAdornment={endAdornment ?? (googleMaps ? <img src={GoogleMaps} alt="Google_Maps" style={{ width: "20px", height: "20px"}} /> : null)}
               onChange={onChangeHandler}
               color="secondary"
               fullWidth={fullWidth}
               disabled={disabled}
               inputProps={inputProps}
               sx={{
                   bgcolor: 'white',
                   '& .MuiInputBase-input': {
                       fontSize: 14.5,
                       height: condensed ? 15 : null,
                   }
               }}
           />
       );
   }
);

export default InputWithIcon;
